import { render, staticRenderFns } from "./ManageStarsModal.vue?vue&type=template&id=19753cc2"
import script from "./ManageStarsModal.vue?vue&type=script&lang=js"
export * from "./ManageStarsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports